import { Component, OnInit } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

import { getActivityDetailRouteName } from '~/attendee/helpers/activity/activity-detail-route-name.helper';
import { TitleService } from '~/core/services/title/title.service';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-organizer-activity-sharing-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss'],
})
export class OrganizerActivitySharingPageShareComponent implements OnInit {
  private readonly frontBaseUrl = environment.applications.front.url;

  constructor(
    private readonly titleService: TitleService,
    protected readonly activityService: OrganizerSharedActivityService,
    private readonly localizeRouterService: LocalizeRouterService
  ) {}

  public ngOnInit(): void {
    this.titleService.setPageTitle(
      'seo.organizer.activity_sharing.share.title'
    );
  }

  public get activityUrl(): string {
    const path = getActivityDetailRouteName(
      this.activityService?.activity.type,
      this.activityService?.activity.sku
    );
    return (
      this.frontBaseUrl +
      this.localizeRouterService.translateRoute(path).toString()
    );
  }
}
